export const filterButtonsWithPermissions = (buttons, permissions, isSuperAdmin) => {
  return [
    {
      className: "menu-box",
      menu: buttons.filter((button) => {
        if (isSuperAdmin) return true;
        if (
          permissions[button.active] === "Not Allow" ||
          !permissions[button.active]
        ) {
          return false;
        }
        return true;
      }),
    }]
};

export const isWriteAccess = (permissions, key) => {
  return (permissions[key] === 'Write');
};
export const isAccess = (permissions, key) => {
  return (permissions[key] === 'Allow');
};

export const isPageAllowed = (permissions, pageRoute) => {
  return (
    (permissions[pageRoute] !== 'Not Allow') &&
    permissions[pageRoute]
  );
};